.container {
	width: 100vw;
	height: 100vh;
	display: block;
	position: fixed;
	top: 0;
	left: 0;
}

.body {
	height: 100%;
	display: flex;
	gap: 0;
	overflow-y: hidden;
	background-color: var(--elevation-default);
}

.main {
	width: 100%;
	height: 100%;
	display: flex;
	flex-direction: column;
	background-color: var(--elevation-default);
}
